<template>
  <div class="argi-login">
    <div class="argi-login-panel">
      <h1>登录</h1>
      <el-form :model="loginData" :rules="rules" ref="loginForm" @keydown.enter.native="submitForm">
        <el-form-item label="账号" prop="username">
          <el-input v-model="loginData.username" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginData.password" show-password placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="submitForm">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="register">没有账号？<span @click="register">点此注册</span></div> -->
  </div>
</template>

<script>
import apis from '@/api'
export default {
  data() {
    return {
      loginData: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // localStorage.setItem('token', 'o2HmJvfVRs2NZ6tbEVGbxg')

    if (localStorage.getItem('token')) {
      this.$router.push('/admin')
    }
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const request = {
            ...apis.USER_LOGIN,
            params: {
              ...this.loginData
            }
          }
          this.$request(request)
            .asyncThen(
              (resp) => {
                if (resp.rst === 200) {
                  localStorage.setItem('username', resp.data.username)
                  localStorage.setItem('token', resp.data.token)
                  localStorage.setItem('registerTime', resp.data.register_time)
                  localStorage.setItem('groupIds', resp.data.group_ids)
                  localStorage.setItem('roleId', resp.data.role_id)
                  this.$router.push({ path: '/admin' })
                }
              },
              (err) => {
                console.error(err)
              }
            )
            .asyncErrorCatch((err) => {
              console.error('额外错误处理:', err)
            })
        } else {
          return false
        }
      })
    },
    register() {
      this.$parent.loginIs = false
    }
  }
}
</script>

<style>
.argi-login {
  position: absolute;
  top: 20%;
  left: 15%;
  width: 70%;

  .argi-login-panel {
    padding: 0 32px;
    width: 100%;
    height: 447px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 2px 12px 0 #00000040;

    h1 {
      padding: 16px 0;
      color: #0A331B;
      font-size: 36px;
      text-align: center;
    }

    .el-form-item {
      .el-form-item__label {
        padding-bottom: 4px;
        color: #476653;
        font-size: 16px;

        &::before {
          display: none;
        }
      }

      .el-input__inner {
        height: 56px;
        line-height: 56;
        background: #f0f4f5;
        border-radius: 6px;
        color: #0A331B;
        font-size: 16px;
      }

      .el-button--success {
        margin-top: 30px;
        width: 100%;
        height: 56px;
        border-radius: 277px;
        font-size: 18px;
      }
    }
  }

  .register {
    padding-top: 64px;
    text-align: center;
    color: #476653;
    font-size: 16px;
    cursor: pointer;

    span {
      color: #409EFF;
      text-decoration: underline;
    }
  }
}
</style>
